import { ButtonAsyncSearchMultiSelect } from './ButtonAsyncSearchMultiSelect'
import { ButtonAsyncSearchMultiSelectWithTags } from './ButtonAsyncSearchMultiSelectWithTags'
import { ButtonAsyncSearchSelect } from './ButtonAsyncSearchSelect'
import { ButtonAsyncSelect } from './ButtonAsyncSelect'
import { ButtonSearchSelect } from './ButtonSearchSelect'
import { ButtonSelect } from './ButtonSelect'
import { InputAsyncMultiSelect } from './InputAsyncMultiSelect'
import { InputAsyncMultiSelectWithTags } from './InputAsyncMultiSelectWithTags'
import { InputAsyncSelect } from './InputAsyncSelect'
import { InputSelect } from './InputSelect'

function Selects() {
  return (
    <>
      <InputSelect />
      <ButtonSelect />
      <ButtonSearchSelect />
      <InputAsyncSelect />
      <InputAsyncMultiSelect />
      <InputAsyncMultiSelectWithTags />
      <ButtonAsyncSelect />
      <ButtonAsyncSearchSelect />
      <ButtonAsyncSearchMultiSelect />
      <ButtonAsyncSearchMultiSelectWithTags />
    </>
  )
}

export default Selects
